import Link from 'next/link';
import React from 'react';

interface Props {
    title: string;
    copy: string;
    cta?: {
        ctaLink: string;
        ctaLabel: string;
    };
}

export const ProfileBannerMessage: React.FC<Props> = ({ title, copy, cta }) => {
    return (
        <div className="banner">
            <div className={`description-container${cta ? ' has-cta' : ''}`}>
                <h2 className="title">{title}</h2>
                <p className="subtitle" dangerouslySetInnerHTML={{ __html: copy }} />
            </div>
            {cta && (
                <Link href={cta.ctaLink}>
                    <a className="button blue-button large-button">{cta.ctaLabel}</a>
                </Link>
            )}
        </div>
    );
};
